import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Card, CardBody, Col, Row, Table, Pagination, PaginationItem, PaginationLink, Spinner, Button } from "reactstrap"
import { connect } from "react-redux"
import { getReportedMessages, changeReportedMessageStatus } from "../../store/dashboard-saas/actions"
import { useHistory } from "react-router-dom"

const ReportedMessages = props => {
  const [currentPage, setCurrentPage] = useState(1)
  const limit = 10
  const history = useHistory()

  useEffect(() => {
    props.getReportedMessages({ page: currentPage, limit })
  }, [currentPage, props.getReportedMessages])

  const handlePageClick = (page) => {
    setCurrentPage(page)
  }

  const navigateToChat = (parenting_space_id, room_id) => {
    // Update the spaceId in local storage before navigating
    localStorage.setItem('spaceId', parenting_space_id)
    history.push(`/chat/${parenting_space_id}?room_id=${room_id}`)
  }

  const handleStatusChange = (reported_message_id) => {
    props.changeReportedMessageStatus({
      reported_message_id: reported_message_id,
      status: "complete"
    })
  }

  const renderPagination = () => {
    const totalPages = props.reportedMessages?.total_pages || 1
    return (
      <Pagination className="pagination pagination-rounded justify-content-end mb-2">
        <PaginationItem disabled={currentPage === 1}>
          <PaginationLink previous onClick={() => handlePageClick(currentPage - 1)} />
        </PaginationItem>
        {[...Array(totalPages)].map((_, i) => (
          <PaginationItem active={currentPage === i + 1} key={i}>
            <PaginationLink onClick={() => handlePageClick(i + 1)}>
              {i + 1}
            </PaginationLink>
          </PaginationItem>
        ))}
        <PaginationItem disabled={currentPage === totalPages}>
          <PaginationLink next onClick={() => handlePageClick(currentPage + 1)} />
        </PaginationItem>
      </Pagination>
    )
  }

  return (
    <React.Fragment>
      <Col xl="12">
        <Card>
          <CardBody>
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h4 className="card-title mb-0">Reported Messages</h4>
              {props.loading && <Spinner color="primary" />}
            </div>
            <div className="table-responsive">
              <Table className="table table-centered table-nowrap mb-0">
                <thead className="thead-light">
                  <tr>
                    <th>Message</th>
                    <th>Reported By</th>
                    <th>Message Type</th>
                    <th>Status</th>
                    <th>Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {props.reportedMessages?.data?.data?.map((message, i) => (
                    <tr key={i}>
                      <td>{message.message.message}</td>
                      <td>
                        <div className="d-flex align-items-center">
                          {message.user.profile_pic && (
                            <img
                              className="rounded-circle avatar-xs me-2"
                              src={message.user.profile_pic}
                              alt=""
                            />
                          )}
                          {message.user.name}
                        </div>
                      </td>
                      <td>{message.message.message_type}</td>
                      <td>
                        <span className={`badge badge-pill badge-soft-${
                          message.status === "in_review" ? "warning" : "success"
                        } font-size-11`}>
                          {message.status}
                        </span>
                      </td>
                      <td>{new Date(message.created_at).toLocaleDateString()}</td>
                      <td>
                        <div className="d-flex gap-2">
                          <Button
                            color="primary"
                            size="sm"
                            onClick={() => navigateToChat(message.parenting_space_id, message.message.room_id)}
                          >
                            <i className="fas fa-comments me-1"></i> Go to Chat
                          </Button>
                          {message.status !== "complete" && (
                            <Button
                              color="success"
                              size="sm"
                              onClick={() => handleStatusChange(message.id)}
                              disabled={props.loading}
                            >
                              <i className="fas fa-check me-1"></i> Mark Complete
                            </Button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            {renderPagination()}
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  )
}

ReportedMessages.propTypes = {
  getReportedMessages: PropTypes.func.isRequired,
  changeReportedMessageStatus: PropTypes.func,
  loading: PropTypes.bool.isRequired,
  reportedMessages: PropTypes.shape({
    total_pages: PropTypes.number,
    data: PropTypes.shape({
      data: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          message: PropTypes.shape({
            message: PropTypes.string,
            message_type: PropTypes.string,
            room_id: PropTypes.string,
          }),
          user: PropTypes.shape({
            name: PropTypes.string,
            profile_pic: PropTypes.string,
          }),
          status: PropTypes.string,
          created_at: PropTypes.string,
          parenting_space_id: PropTypes.number,
        })
      ),
    }),
  }),
}

ReportedMessages.defaultProps = {
  reportedMessages: {
    total_pages: 1,
    data: {
      data: [],
    },
  },
  changeReportedMessageStatus: () => {},
}

const mapStateToProps = state => ({
  reportedMessages: state.DashboardSaas.reportedMessages,
  loading: state.DashboardSaas.loading,
})

export default connect(mapStateToProps, { getReportedMessages, changeReportedMessageStatus })(ReportedMessages)